<template>
  <DialogFull :data="dialogSettings" @close="close">
    <div class="container col-lg-8 col-sm-12">
      <FileUpload
        @unselectFile="unselectFile"
        @selectFile="selectFile"
        :uploadingUrl="addFileUrl"
        :fileTypes="['application/pdf']"
        :isLoading="isLoading"
        disableAutoProceed
        customActions
        :files="files"
        showPreview
        @show="showFile"
      />
      <PDFViewFull :data="fileDialog" />
      <div class="d-flex justify-end">
        <PrimaryButton @click.native="onSave" :loading="isLoading">
          Save Changes
        </PrimaryButton>
      </div>
    </div>
  </DialogFull>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import DialogFull from "@/components/common/DialogFull";
import { USERS_NAMESPACE } from "@/store/modules/users";
import { FETCH_CURRENT_USER } from "@/store/modules/users/actions";
import FileUpload from "@/components/common/FileUpload";
import PDFViewFull from "@/components/common/PDFViewFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { first } from "lodash";
import APIService from "@/services/APIService";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import { DELETE_WORKER_CV } from "@/store/modules/workers/action-types";
import { WORKERS_NAMESPACE } from "@/store/modules/workers";
import { getFilePreviewSettings } from "@/utils/files";

const { mapActions: mapUserActions } = createNamespacedHelpers(USERS_NAMESPACE);
const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);
const { mapActions: mapWorkerActions } = createNamespacedHelpers(
  WORKERS_NAMESPACE
);

export default {
  components: {
    DialogFull,
    PDFViewFull,
    FileUpload,
    PrimaryButton
  },
  props: {
    isOpen: Boolean
  },
  data() {
    return {
      uppyInstance: null,
      fileToBeRemoved: null,
      isLoading: false,
      fileDialog: {
        dialog: false
      },
      files: []
    };
  },
  created() {
    if (this.userData.cv) {
      this.files = [this.userData.cv];
    }
  },
  computed: {
    ...mapAuthState({
      userData: state => state.userData
    }),
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "CV"
      };
    },
    addFileUrl() {
      const host = APIService.host;
      return `${host}/users/${this.userData.id}/cv`;
    },
    currentFile() {
      return first(this.files);
    }
  },
  methods: {
    ...mapUserActions({
      fetchCurrentUser: FETCH_CURRENT_USER
    }),
    ...mapWorkerActions({
      removeFile: DELETE_WORKER_CV
    }),
    async unselectFile({ uppyInstance, file: fileToBeRemoved }) {
      if (fileToBeRemoved.url) {
        this.fileToBeRemoved = fileToBeRemoved;
      }
      this.files = [];
      uppyInstance.reset();
    },
    selectFile({ uppyInstance, file }) {
      this.uppyInstance = uppyInstance;
      this.files = [file];
    },
    async onSave() {
      this.isLoading = true;
      if (this.fileToBeRemoved) {
        await this.removeFile(this.userData.id);
      }
      if (this.uppyInstance && this.currentFile) {
        await this.uppyInstance.upload(this.currentFile.id);
      }
      this.isLoading = false;
      this.fetchCurrentUser();
      this.close();
    },
    close() {
      this.$emit("close");
    },
    async showFile(file) {
      const filePreviewSettings = await getFilePreviewSettings(file);
      this.fileDialog = {
        ...filePreviewSettings,
        dialog: true
      };
    }
  }
};
</script>

<style lang="scss"></style>
